/**
 * useUserInfo Hook
 * 사용자 정보 검증 및 조회 훅
 */
import { ToastType } from "@/shared/components/feedback/Toast/Toast.types";
import { useToast } from "@/shared/components/feedback/Toast/ToastContext";
import { getItem, STORAGE_KEYS } from '@/shared/utils/storage';
import { PartnerPortalLoginResponse } from '@/features/auth/types/auth.types';

/**
 * 사용자 정보 검증 및 가져오기 훅
 * localStorage에서 사용자 정보를 조회하고 유효성을 검증
 */
export const useUserInfo = () => {
    const { showToast } = useToast();

    /**
     * localStorage에서 사용자 정보를 가져오고 검증
     * @returns 사용자 정보 또는 null (검증 실패시)
     */
    const getUserInfo = (): PartnerPortalLoginResponse | null => {
        const userInfo = getItem<PartnerPortalLoginResponse>(STORAGE_KEYS.USER_INFO);
        if (!userInfo || !userInfo.userId) {
            showToast('로그인 정보를 찾을 수 없습니다.', { type: ToastType.ERROR });
            return null;
        }
        return userInfo;
    };

    return { getUserInfo };
};
